import { ILmpHero, LmpHero } from "@sky-it-livedata/livedata-sports-design-system";
import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { LmpHeroQuery, LmpHeroSubscription } from "./types";
import transformQuery from "./transformers/query";
import transformSubscription from "./transformers/subscription";
import { graphql } from "appsync";
import { useSubscription } from "../../hooks/useSubscription";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<LmpHeroQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

const subscriptionDocument = graphql('subscription LmpHeroSubscription($matchId: ID!) {\n  onUpdateLmpHeroByMatchId(matchId: $matchId) {\n    matchId\n    status\n    statusStartDateTime\n    home {\n      goal\n      overtimeGoal\n      penaltiesGoal\n      regularTimeGoal\n      shootoutGoal\n      totalGoalLegs\n      scoreboard {\n        minute\n        player\n        type\n        matchStatus\n      }\n    }\n    away {\n      goal\n      overtimeGoal\n      penaltiesGoal\n      regularTimeGoal\n      shootoutGoal\n      totalGoalLegs\n      scoreboard {\n        minute\n        player\n        type\n        matchStatus\n      }\n    }\n  }\n}');

export const getServerProps = ({
  props,
}: WidgetContext<LmpHeroQuery>): ILmpHero => {
  

  return transformQuery(props);
}

const LmpHeroWidget = ({
  props,
  variables,
  ...rest
}: WidgetContext<ILmpHero>) => {
  log({ props, variables, ...rest });

   const updatedProps = useSubscription<
    ILmpHero,
    LmpHeroSubscription,
    typeof subscriptionDocument
  >({
    initialData: props,
    graphQLDocument: subscriptionDocument,
    variables,
    transform: transformSubscription,
    mergeData: true,
  }) as ILmpHero;

  return (
    <LmpHero {...updatedProps} />
  );
}

export default LmpHeroWidget;